import { useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion";
import { ChevronRight, ChevronLeft, ZoomIn, X } from "lucide-react";
import heroImage from "@/assets/quadra-poliesportiva.jpg";
import quadraTenis from "@/assets/quadra-tenis.jpg";
import quadraDupla from "@/assets/quadras-duplas.jpg";
import quadraAzul from "@/assets/quadra-azul.jpg";
import complexoTenis from "@/assets/complexo-tenis.jpg";
import pickleballCinzaAzul from "@/assets/pickleball-cinza-azul.jpg";
import pickleballAzulVerde from "@/assets/pickleball-azul-verde.jpg";
import quadraTenisClose from "@/assets/quadra-tenis-close.jpg";
import complexoQuadrasAsfalto from "@/assets/complexo-quadras-poliesportivas-tenis-asfalto.jpg";
import meiaQuadraCinza from "@/assets/meia-quadra-basquete-cinza.jpg";
import pickleballTextura from "@/assets/quadra-pickleball-textura-jogo.jpg";
import tenisCinzaVerde from "@/assets/quadra-tenis-asfalto-cinza-verde.jpg";
import tenisAzulTijolo from "@/assets/quadra-tenis-azul-tijolo.jpg";
import tenisMontanhas from "@/assets/quadra-tenis-montanhas.jpg";
import tenisVerdeAsfalto from "@/assets/quadra-tenis-asfalto-verde-alto-padrao.jpg";
import tenisVerdeTijolo from "@/assets/quadra-tenis-verde-tijolo-condominio.jpg";
import tenisVerdeClaroEscuro from "@/assets/quadra-tenis-verde-claro-escuro.jpg";
import tenisVerdeAzulFloresta from "@/assets/quadra-tenis-verde-azul-floresta.jpg";
import quadraHotel from "@/assets/quadra-tenis-hotel-luxo.jpg";
import poliesportivaAzulVerde2 from "@/assets/quadra-poliesportiva-azul-verde-2.jpg";
import poliesportivaAzulAmarela from "@/assets/quadra-poliesportiva-azul-verde-demarcacao.jpg";
import poliesportivaDemarcacao from "@/assets/quadra-poliesportiva-futsal-volei-basquete-pickleball.jpg";
import quadrasCondominio from "@/assets/quadras-condominio-alto-padrao.jpg";
import quadraTenisAereaVerdeTijoloVistaDrone from "@/assets/quadra-tenis-aerea-verde-tijolo-vista-drone.jpg";
import quadraTenisAereaVermelhaVerdeDrone from "@/assets/quadra-tenis-aerea-vermelha-verde-drone.jpg";
import quadraTenisAereaMultiplasQuadrasDrone from "@/assets/quadra-tenis-aerea-multiplas-quadras-drone.jpg";
import quadraTenisAereaAzulPiscinaPalmeiras from "@/assets/quadra-tenis-aerea-azul-piscina-palmeiras-drone.jpg";
import quadraTenisVistaPanoramicaMultiplasQuadrasVerdes from "@/assets/quadra-tenis-vista-panoramica-multiplas-quadras-verdes.jpeg";
import quadraTenisTerracotaIluminacaoNoturna from "@/assets/quadra-tenis-terracota-iluminacao-noturna.jpg";
import quadraTenisVerdeClubeBannersBabolat from "@/assets/quadra-tenis-verde-clube-banners-babolat.jpg";
import quadraTenisAereaDuasQuadrasAzuisPoliesportiva from "@/assets/quadra-tenis-aerea-duas-quadras-azuis-poliesportiva.jpeg";
import quadraTenisTerracotaVerdePalmeirasEvento from "@/assets/quadra-tenis-terracota-verde-palmeiras-evento.jpeg";
import quadraTenisVerdeClubeMultiplasQuadras from "@/assets/quadra-tenis-verde-clube-multiplas-quadras.jpg";
import quadraTenisAereaVerdeVermelhaLago from "@/assets/quadra-tenis-aerea-verde-vermelha-lago.jpg";
import quadraTenisRoxaVerdeAcabamento from "@/assets/quadra-tenis-roxa-verde-acabamento.jpg";
import quadraPoliesportivaAereaVerdeVermelhaDrone from "@/assets/quadra-poliesportiva-aerea-verde-vermelha-drone.jpg";
import quadraPoliesportivaAereaDuplaVerdeVermelhaCondominio from "@/assets/quadra-poliesportiva-aerea-dupla-verde-vermelha-condominio.jpg";
import quadraPoliesportivaAereaAzulCercadaArvores from "@/assets/quadra-poliesportiva-aerea-azul-cercada-arvores.jpg";
import quadraPoliesportivaAereaVistaPanoramicaLago from "@/assets/quadra-poliesportiva-aerea-vista-panoramica-lago.jpg";
import quadraPoliesportivaAzulVerdeUrbanaPalmeiras from "@/assets/quadra-poliesportiva-azul-verde-urbana-palmeiras.jpg";
import quadraPoliesportivaCobertaVerdeVermelhaGinasio from "@/assets/quadra-poliesportiva-coberta-verde-vermelha-ginasio.jpg";
import quadraPoliesportivaAereaAzulVerdeJardimResidencial from "@/assets/quadra-poliesportiva-aerea-azul-verde-jardim-residencial.jpeg";
import quadraPoliesportivaAereaDuplaAzulRural from "@/assets/quadra-poliesportiva-aerea-dupla-azul-rural.jpeg";
import quadraPoliesportivaCinzaVermelhaCestaArvores from "@/assets/quadra-poliesportiva-cinza-vermelha-cesta-arvores.jpeg";
import quadraPoliesportivaAereaAzulVerdeQuadrasTenisProximas from "@/assets/quadra-poliesportiva-aerea-azul-verde-quadras-tenis-proximas.jpeg";
import quadraPoliesportivaVermelhaVerdeClubePredio from "@/assets/quadra-poliesportiva-vermelha-verde-clube-predio.jpg";
import quadraPoliesportivaAzulVerdeRedeVoleiVistaAmpla from "@/assets/quadra-poliesportiva-azul-verde-rede-volei-vista-ampla.jpeg";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] as const } },
};

const stagger = {
  visible: { transition: { staggerChildren: 0.1 } },
};

const galleryImages = [
  { img: heroImage, alt: "Quadra poliesportiva com sistema de pintura Indusport" },
  { img: quadraTenis, alt: "Quadra de tênis com sistema Indusport" },
  { img: pickleballAzulVerde, alt: "Quadra de pickleball azul e verde com resina Indusport" },
  { img: pickleballCinzaAzul, alt: "Quadras de pickleball em cinza e azul com sistema Indusport" },
  { img: quadraTenisClose, alt: "Close da textura de quadra de tênis com resina Indusport" },
  { img: quadraDupla, alt: "Quadras duplas com pintura Indusport" },
  { img: quadraAzul, alt: "Quadra azul com sistema de pintura Indusport" },
  { img: complexoTenis, alt: "Complexo de tênis com pintura Indusport" },
  { img: complexoQuadrasAsfalto, alt: "Complexo esportivo com quadras poliesportivas e de tênis em piso asfáltico" },
  { img: meiaQuadraCinza, alt: "Meia quadra de basquete em cinza claro e escuro em propriedade particular" },
  { img: pickleballTextura, alt: "Quadra de pickleball com textura ideal de jogo — resina Indusport" },
  { img: tenisCinzaVerde, alt: "Quadra de tênis em piso asfáltico nas cores cinza e verde claro" },
  { img: tenisAzulTijolo, alt: "Quadra de tênis com tinta azul e tijolo — textura ideal de jogo" },
  { img: tenisMontanhas, alt: "Quadra de tênis em meio às montanhas com revestimento Indusport" },
  { img: tenisVerdeAsfalto, alt: "Quadra de tênis em piso asfáltico na cor verde em propriedade de alto padrão" },
  { img: tenisVerdeTijolo, alt: "Quadra de tênis verde e tijolo em condomínio de alto padrão" },
  { img: tenisVerdeClaroEscuro, alt: "Quadra de tênis verde claro e escuro com sistema Indusport" },
  { img: tenisVerdeAzulFloresta, alt: "Quadra de tênis verde e azul integrada em área de floresta" },
  { img: quadraHotel, alt: "Quadra de tênis em hotel de luxo com pintura Indusport" },
  { img: poliesportivaAzulVerde2, alt: "Quadra poliesportiva azul e verde com sistema Indusport" },
  { img: poliesportivaAzulAmarela, alt: "Quadra poliesportiva azul e verde com demarcações amarelas e pretas" },
  { img: poliesportivaDemarcacao, alt: "Quadra poliesportiva com demarcação para futsal, vôlei, basquete e pickleball" },
  { img: quadrasCondominio, alt: "Quadras esportivas em condomínio de alto padrão — sistema Indusport" },
  { img: quadraTenisAereaVerdeTijoloVistaDrone, alt: "Vista aérea de quadra de tênis verde e tijolo com sistema Indusport" },
  { img: quadraTenisAereaVermelhaVerdeDrone, alt: "Vista aérea de quadra de tênis vermelha e verde — pintura Indusport" },
  { img: quadraTenisAereaMultiplasQuadrasDrone, alt: "Vista aérea de complexo com múltiplas quadras de tênis Indusport" },
  { img: quadraTenisAereaAzulPiscinaPalmeiras, alt: "Vista aérea de quadra de tênis azul ao lado de piscina com palmeiras" },
  { img: quadraTenisVistaPanoramicaMultiplasQuadrasVerdes, alt: "Vista panorâmica de múltiplas quadras de tênis verdes com sistema Indusport" },
  { img: quadraTenisTerracotaIluminacaoNoturna, alt: "Quadra de tênis terracota com iluminação noturna — pintura Indusport" },
  { img: quadraTenisVerdeClubeBannersBabolat, alt: "Quadra de tênis verde em clube esportivo com pintura Indusport" },
  { img: quadraTenisAereaDuasQuadrasAzuisPoliesportiva, alt: "Vista aérea de quadras azuis de tênis e poliesportiva" },
  { img: quadraTenisTerracotaVerdePalmeirasEvento, alt: "Quadra de tênis terracota e verde com palmeiras — sistema Indusport" },
  { img: quadraTenisVerdeClubeMultiplasQuadras, alt: "Múltiplas quadras de tênis verdes em clube com sistema Indusport" },
  { img: quadraTenisAereaVerdeVermelhaLago, alt: "Vista aérea de quadra de tênis verde e vermelha próxima a um lago" },
  { img: quadraTenisRoxaVerdeAcabamento, alt: "Quadra de tênis roxa e verde com acabamento Indusport" },
  { img: quadraPoliesportivaAereaVerdeVermelhaDrone, alt: "Vista aérea de quadra poliesportiva verde e vermelha com sistema Indusport" },
  { img: quadraPoliesportivaAereaDuplaVerdeVermelhaCondominio, alt: "Vista aérea de quadras poliesportivas duplas em condomínio" },
  { img: quadraPoliesportivaAereaAzulCercadaArvores, alt: "Vista aérea de quadra poliesportiva azul cercada por árvores" },
  { img: quadraPoliesportivaAereaVistaPanoramicaLago, alt: "Vista aérea panorâmica de quadras esportivas com lago ao fundo" },
  { img: quadraPoliesportivaAzulVerdeUrbanaPalmeiras, alt: "Quadra poliesportiva azul e verde em área urbana com palmeiras" },
  { img: quadraPoliesportivaCobertaVerdeVermelhaGinasio, alt: "Quadra poliesportiva coberta verde e vermelha em ginásio" },
  { img: quadraPoliesportivaAereaAzulVerdeJardimResidencial, alt: "Vista aérea de quadra poliesportiva azul e verde em jardim residencial" },
  { img: quadraPoliesportivaAereaDuplaAzulRural, alt: "Vista aérea de quadras poliesportivas azuis em área rural" },
  { img: quadraPoliesportivaCinzaVermelhaCestaArvores, alt: "Quadra poliesportiva cinza e vermelha com cesta de basquete" },
  { img: quadraPoliesportivaAereaAzulVerdeQuadrasTenisProximas, alt: "Vista aérea de quadra poliesportiva e quadras de tênis próximas" },
  { img: quadraPoliesportivaVermelhaVerdeClubePredio, alt: "Quadra poliesportiva vermelha e verde em clube esportivo" },
  { img: quadraPoliesportivaAzulVerdeRedeVoleiVistaAmpla, alt: "Quadra poliesportiva azul e verde com rede de vôlei" },
];

const GallerySection = () => {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const [page, setPage] = useState(0);
  const [cols, setCols] = useState(4);

  useEffect(() => {
    const update = () => setCols(window.innerWidth >= 768 ? 4 : 2);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const itemsPerPage = cols * 2;
  const totalPages = Math.ceil(galleryImages.length / itemsPerPage);
  const visibleImages = galleryImages.slice(page * itemsPerPage, (page + 1) * itemsPerPage);

  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevLightbox = useCallback(() => setLightboxIndex((i: number | null) => i === null ? null : (i - 1 + galleryImages.length) % galleryImages.length), []);
  const nextLightbox = useCallback(() => setLightboxIndex((i: number | null) => i === null ? null : (i + 1) % galleryImages.length), []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeLightbox();
      else if (e.key === "ArrowLeft") prevLightbox();
      else if (e.key === "ArrowRight") nextLightbox();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightboxIndex, closeLightbox, prevLightbox, nextLightbox]);

  useEffect(() => {
    document.body.style.overflow = lightboxIndex !== null ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [lightboxIndex]);

  return (
    <section className="py-20 md:py-28">
      <div className="container">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={stagger}>
          <motion.div variants={fadeUp} className="mb-12 max-w-2xl">
            <span className="mb-3 inline-block font-mono text-xs uppercase tracking-[0.2em] text-accent">Portfólio</span>
            <h2 className="text-3xl font-extrabold tracking-tighter md:text-4xl">
              Superfícies que comprovam o sistema de pintura.
            </h2>
          </motion.div>

          <div className="relative">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {visibleImages.map((item, i) => {
                const globalIndex = page * itemsPerPage + i;
                return (
                  <div
                    key={globalIndex}
                    className="group relative overflow-hidden aspect-[4/3] cursor-pointer"
                    onClick={() => setLightboxIndex(globalIndex)}
                  >
                    <img srcSet={item.img} sizes="(min-width:768px) 25vw, 50vw" alt={item.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                      <ZoomIn className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>
                  </div>
                );
              })}
            </div>

            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-3 mt-6">
                <button
                  onClick={() => setPage((p: number) => Math.max(0, p - 1))}
                  disabled={page === 0}
                  className="flex h-10 w-10 items-center justify-center border border-border bg-card text-foreground hover:border-primary hover:bg-primary hover:text-primary-foreground transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                  aria-label="Página anterior"
                >
                  <ChevronLeft className="h-5 w-5" />
                </button>
                <span className="font-mono text-xs text-muted-foreground tracking-widest">{page + 1} / {totalPages}</span>
                <button
                  onClick={() => setPage((p: number) => Math.min(totalPages - 1, p + 1))}
                  disabled={page === totalPages - 1}
                  className="flex h-10 w-10 items-center justify-center border border-border bg-card text-foreground hover:border-primary hover:bg-primary hover:text-primary-foreground transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                  aria-label="Próxima página"
                >
                  <ChevronRight className="h-5 w-5" />
                </button>
              </div>
            )}
          </div>
        </motion.div>
      </div>

      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
          onClick={closeLightbox}
        >
          <button
            className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center text-white/70 hover:text-white transition-colors"
            onClick={closeLightbox}
            aria-label="Fechar"
          >
            <X className="h-7 w-7" />
          </button>

          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 z-10 flex h-12 w-12 items-center justify-center text-white/70 hover:text-white transition-colors"
            onClick={(e) => { e.stopPropagation(); prevLightbox(); }}
            aria-label="Imagem anterior"
          >
            <ChevronLeft className="h-9 w-9" />
          </button>

          <img
            srcSet={galleryImages[lightboxIndex].img}
            sizes="90vw"
            alt={galleryImages[lightboxIndex].alt}
            className="max-h-[85vh] max-w-[80vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />

          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 z-10 flex h-12 w-12 items-center justify-center text-white/70 hover:text-white transition-colors"
            onClick={(e) => { e.stopPropagation(); nextLightbox(); }}
            aria-label="Próxima imagem"
          >
            <ChevronRight className="h-9 w-9" />
          </button>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 font-mono text-xs text-white/50 tracking-widest">
            {lightboxIndex + 1} / {galleryImages.length}
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
